/**
 * 用户登录注册行为端，对齐后端的 login_source 字段
 * 不同于入口位置的 Entry 概念
 */
export const AuthSource = {
    /** PC 端 */
    pc: 1,
    /** 移动端 */
    mobile: 2,
    /** 抖音客户端 */
    douyin: 3,
    /** 小程序 */
    microapp: 4,
    /** 抖音任务台 */
    douyinConsole: 5,
    /** 头条任务台 */
    toutiaoConsole: 6,
    /** 游戏发行人 */
    game: 7,
    /** 星图合伙人 */
    partner: 8,
};
